import { Model } from '@vuex-orm/core';
import { AxiosResponse } from 'axios';
import ImageAPI from '@/api/ImageAPI';

export default class Image extends Model {

    public static entity = 'image';

    public static fields() {
        return {
            id: this.string(null),
            image: this.string(''),
            uuid: this.string(''),
            title: this.string(''),
            fileSize: this.string(''),
            type: this.string(''),
        };
    }

    public static async createNew(formData: FormData) {
        let image;
        try {
            image = await ImageAPI.createNew(formData) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        this.insertOrUpdate({
            data: image.data,
        });

        return Promise.resolve(image);
    }

    public static async updateExisting(file: any) {
        let image;
        try {
            image = await ImageAPI.updateExisting(file) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        this.insertOrUpdate({
            data: image.data,
        });

        return Promise.resolve(image);
    }

    public id!: string;
    public image!: string;
    public uuid!: string;
    public fileSize!: string;
    public title!: string;
    public type!: string;
}
